<template>
  <div class="pb-1">
    <label
      for="namaSpesifikasiBarang"
      class="d-block col-form-label-lg pb-0 pt-0"
    >
      3. Nama Spesifikasi Barang
      <feather-icon
        icon="AlertCircleIcon"
        class="text-warning"
        v-b-tooltip.hover
        title="Diisi dengan nama spesifikasi barang milik daerah berupa nama gedung atau bangunan tersebut. Contoh: Gedung Sekolah SMAN 51 Jakarta Timur"
      />
    </label>
    <b-form-input
      id="namaSpesifikasiBarang"
      v-model="namaSpesifikasiBarang"
      :state="stateNamaSpesifikasiBarang"
    />
    <b-form-invalid-feedback
      v-for="(error, index) of errorsNamaSpesifikasiBarang"
      :key="index"
    >
      {{ error.$message }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import { ref, watchEffect, watch } from "@vue/composition-api";
import { propsString, propsBoolean, propsArray } from "@/utils/propsTipeData";

export default {
  setup(props, context) {
    let namaSpesifikasiBarang = ref("");

    watch(namaSpesifikasiBarang, () => {
      context.emit("emitNamaSpesifikasiBarang", namaSpesifikasiBarang.value);
    });

    watchEffect(() => {
      namaSpesifikasiBarang.value = props.namaSpesifikasiBarangVal;
    });

    return { namaSpesifikasiBarang };
  },
  props: {
    namaSpesifikasiBarangVal: propsString,
    stateNamaSpesifikasiBarang: propsBoolean,
    errorsNamaSpesifikasiBarang: propsArray,
  },
};
</script>